import CartController from "emun.cart/cart.controller";
import ProductListPicker from "emun.products/lists/product-list-picker";
import $pageConfig from "webutils/services/page-config";
import labels from "emun.products/_labels";
import open from "webmodals/open";

export default class ShopController extends CartController {
  constructor($cart) {
    super($cart);
    const $ctrl = this;
  }

  $onInit() {
    const $ctrl = this;
    if (!$ctrl.container && $ctrl.shoppingContainer)
      $ctrl.container = $ctrl.shoppingContainer;
    if ($ctrl.product) {
      $ctrl.quantity = $ctrl.product.minimumOrderQty;
      if (!$ctrl.container && $ctrl.product.shoppingContainer)
        $ctrl.container = $ctrl.product.shoppingContainer;
    }
    $ctrl.$pageConfig = $pageConfig;
    $ctrl.productLabels = labels;
    $ctrl.settings = {
      preset: "decimal",
      scale: 0,
      display: "center",
      min: $ctrl.product ? $ctrl.product.minimumOrderQty : 0,
      max: 100000,
      showOnTap: true,
      onShow(event, inst) {
        inst.setVal("0");
      },
      buttons: [
        "cancel",
        {
          text: "Add",
          handler: "set",
        },
      ],
    };
  }

  increment() {
    if (this.product) {
      var increment =
        this.product.purchaseIncrement || this.product.minimumOrderQty;
      this.quantity += increment;
    }
  }
  decrement() {
    if (this.product) {
      var increment =
        this.product.purchaseIncrement || this.product.minimumOrderQty;
      this.quantity -= increment;
    }
  }
  getImageUrl(productId, size) {
    return this.$appConfig.productImage(productId, size);
  }

  addToList(product) {
    ProductListPicker.open({ product });
  }

  disabled() {
    const $ctrl = this;
    // if ($ctrl.$state.current.name === "shop.product") {
    //   console.debug(
    //     "ShopController.DISABLED?",
    //     "$ctrl.product.status",
    //     $ctrl.product && $ctrl.product.status,
    //     "$ctrl.$session.salesManagementMode",
    //     $ctrl.$session.salesManagementMode,
    //     "isKitComponent: ",
    //     $ctrl.cartItem.isKitComponent,
    //     "allowOrderEdit: ",
    //     $ctrl.orderConfig.allowOrderEdit,
    //     "canEdit: ",
    //     $ctrl.$cart.canEdit,
    //     "agencyCanEdit: ",
    //     $ctrl.$cart.agencyCanEdit,
    //     "allowOrderEdit: ",
    //     $ctrl.orderConfig.allowOrderEdit,
    //     "isBusy: ",
    //     $ctrl.$cart.isBusy(),
    //     "pageConfig: ",
    //     $ctrl.$pageConfig,
    //     "WriteOrders: ",
    //     $ctrl.$session.hasPermission("WriteOrders")
    //   );
    // }
    if (
      $ctrl.product &&
      ($ctrl.product.status === "Inactive" ||
        $ctrl.$cart.isSkuLocked($ctrl.product.id))
    )
      return true;
    // if ($ctrl.$cart.isBusy()) return true;
    if ($ctrl.$cart.id && !$ctrl.$cart.canEdit && !$ctrl.$cart.agencyCanEdit)
      return true;
    //if ($ctrl.cartItem && $ctrl.cartItem.isKitComponent) return true;
    //BL 5/2/2022 remove salesmanagementmode because b2b users are still able to take orders without the permission set
    //if ($ctrl.$session.salesManagementMode) {
    if (!$ctrl.$cart.token &&
      (!$ctrl.orderConfig.allowOrderEdit ||
        !$ctrl.$session.hasPermission("WriteOrders"))
    )
      return true;
    //}
    return false;
  }
  viewVideoLink(link) {
    const $ctrl = this;
    var videoId = /[^/]*$/.exec(link)[0];
    if (link.indexOf("vimeo") >= 0) $ctrl.viewVimeo({videoId: videoId});
    else if (link.indexOf("youtu.be") >= 0) $ctrl.viewYouTube({videoId: videoId});
  }

  viewVimeo({
    videoId,
    placement,
    backdrop = true,
    size = "lg",
    preventAutoHeight = true,
    title = "View Vimeo video...",
    subTitle = "",
    videoInfo = {},
  } = {}) {
    const $ctrl = this;
    console.info("viewVimeo", { videoId, $ctrl, videoInfo });
    return open({
      size,
      backdrop,
      template: `
      <modal
        modal-title="{{$ctrl.title}}" 
        on-dismiss="$ctrl.$dismiss()">
        <modal-body>
          <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/${videoId}?h=a7bc16d873&autoplay=1&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </modal-body>
        <modal-footer>
        </modal-footer>
      </modal>`,
    placement,
      controller() {
        const $this = this;
        Object.assign($this, {
          $main: $ctrl,
          videoId,
          subTitle,
          title,
          preventAutoHeight,
          videoInfo,
        });
      },
      bindToController: true,
      controllerAs: "$ctrl",
    }).result;
  }

  viewYouTube({
    videoId,
    placement,
    backdrop = true,
    size = "lg",
    preventAutoHeight = true,
    title = "View YouTube video...",
    subTitle = "",
    videoInfo = {},
  } = {}) {
    const $ctrl = this;
    console.info("viewYouTube", { videoId, $ctrl, videoInfo });
    return open({
      size,
      backdrop,
      template: `
      <modal
      modal-title="{{$ctrl.title}}" 
      on-dismiss="$ctrl.$dismiss()">
      <modal-body>
        <div class="text-center">
          <iframe
            type="text/html"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1"
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen" 
            msallowfullscreen="msallowfullscreen" 
            oallowfullscreen="oallowfullscreen" 
            webkitallowfullscreen="webkitallowfullscreen"
            frameborder="0"
          ></iframe> 
        </div>
      </modal-body>
      <modal-footer>
      </modal-footer>
    </modal>`,
      placement,
      controller() {
        const $this = this;
        Object.assign($this, {
          $main: $ctrl,
          videoId,
          subTitle,
          title,
          preventAutoHeight,
          videoInfo,
        });
      },
      bindToController: true,
      controllerAs: "$ctrl",
    }).result;
  }
}
